"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
// import { checkAccount } from "@/api/common"
// import { validUsername } from '@/utils/validate'
// import { setUserInfo, getUserInfo} from "@/utils/auth"
var _default = {
  name: 'Login',
  data: function data() {
    return {
      // loginForm: {
      //   username: '15159457068',
      //   password: 'abc123',
      //   loginType: '2'
      // },
      // rememberMe: true,  // 记住用户
      // loginRules: {
      //   username: [{ required: true, trigger: 'blur', validator: validateUsername }],
      //   password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      // },
      loading: false,
      passwordType: 'password',
      redirect: undefined
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created: function created() {
    var _this = this; // let url = window.location.href; //获取地址栏路径
    // let temp1 = url.indexOf('token') !=-1 ? url.substring(url.lastIndexOf("token=")) : ''
    // if(temp1) {
    //   let pram = temp1.split('=');//对url地址进行分割
    //   let token = pram[1];
    //   _this.handleLogin(token)
    // } else {
    //   window.addEventListener("setItem", () => {
    //     console.log('监听loginSDK')
    //     let data = localStorage.getItem('loginSDK')
    //     let loginSdk = data ? JSON.parse(data) : {}
    //     loginSdk.token ? _this.handleLogin(loginSdk.token) : ''
    //   });
    // }


    _this.handleLogin();
  },
  mounted: function mounted() {},
  methods: {
    showPwd: function showPwd() {
      var _this2 = this;

      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }

      this.$nextTick(function () {
        _this2.$refs.password.focus();
      });
    },
    handleLogin: function handleLogin(token) {
      var _this3 = this;

      this.loading = true;
      var params = {
        code: token,
        login_sp: '432',
        game_id: 'laya_0012',
        sp_id: '431'
      };
      this.$store.dispatch('user/login', params).then(function () {
        _this3.$router.push({
          path: '/'
        });

        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      }); // this.$router.push({ path: '/' })
    }
  }
};
exports.default = _default;